import React, {useState} from 'react';
import {connect} from 'react-redux';
import Numeral from 'numeral';
import {resetAgencyDetails} from '../actions/agencyDetailInfo';
import {getDiffrentTime} from '../utils/DateUtility'
import {enToFa} from '../utils/NumberUtility'
import logo from '../assets/images/C_logo.png';
import ModalComponent from '../components/ModalComponent';
import {startDeleteAlarm} from '../actions/alarms';

const AlarmAdItem = (props) => {

  const [deleteConfirm, setDeleteConfirm] = useState(false);

  const handleCloseRemoveModal = (e) => {
    setDeleteConfirm(false);
  }

    const onItemSelected = (e) => {
      props.resetAgencyDetails()
      props.push(`/alarm/${props.info.id}`)
    }

    const onTrashClicked = (e) => {
      setDeleteConfirm(true)
    }

    const handleSubmitRemoveModal = (e) => {
      props.startDeleteAlarm(props.info.id)
    }

    return (
      <div className={`vehicle-ad mb-3 ${props.classes ? props.classes : '' }`}>
        <div className="optimized__d-flex-class">
          < img className = "vehicle-ad__img col-4 px-2" onClick={onItemSelected}
          src = {logo}
          />
          <div className="optimized__d-flex-class flex-column col-8 justify-content-between" onClick={onItemSelected}>
            <span className="vehicle-ad__title">{enToFa(`${props.info.targetVehicle.category.name} - ${props.info.targetVehicle.brand.name} - ${props.info.targetVehicle.name}`)}</span>
            <span className="vehicle-ad__elapsed-time optimized__d-flex-class">
              <span><i className="simple-icon-clock vehicle-ad__elapsed-logo"></i></span><span>{enToFa(`از سال ${props.info.fromYear} - تا سال ${props.info.toYear}`)}</span>
            </span>
          </div>
          <ModalComponent
              onRequestClose={handleCloseRemoveModal}
              isOpen={deleteConfirm}>
              <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                  <span>آیا از حذف گوش به زنگ اطمینان دارید؟</span>
                  <div className="optimized__d-flex-class justify-content-end pt-3">
                      <button className="btn__close--secondary mx-2" onClick={handleCloseRemoveModal}>انصراف</button>
                      <button className="btn__close mx-0" onClick={handleSubmitRemoveModal}>حذف</button>
                  </div>
              </div>
          </ModalComponent>
        </div>
        <div className="optimized__d-flex-class justify-content-between align-items-center mt-2">
          <div>
            <span className="vehicle-ad__elapsed-time d-block">{enToFa(`از قیمت ${Numeral(props.info.fromPrice).format('0,0')} تومان`)}</span>
            <span className="vehicle-ad__elapsed-time">{enToFa(`تا قیمت ${Numeral(props.info.toPrice).format('0,0')} تومان`)}</span>
          </div>
          <i class="material-icons stock__i" onClick={onTrashClicked}>delete</i>
        </div>
      </div>
    );
}

const mapDispatchToProps = (dispatch) => ({
  resetAgencyDetails: () => dispatch(resetAgencyDetails()),
  startDeleteAlarm: (id) => dispatch(startDeleteAlarm(id))
})

export default connect(undefined, mapDispatchToProps)(AlarmAdItem);